import type { ThunkDispatch, UnknownAction } from '@reduxjs/toolkit'
import { RecipientTypeEnum } from 'Modules/Communication/shared/models/Inbox'
import { RecipientOpenState } from 'Modules/Communication/shared/models/Recipients'
import { FIND_RECIPIENTS_MODAL } from 'shared/constants/modals'
import { closeModal, openModal } from 'shared/store/modal'
import slice from './reducer'

export const handleRecipientModal =
  (payload: { open: RecipientOpenState; type: RecipientTypeEnum | null }) =>
  (dispatch: ThunkDispatch<unknown, unknown, UnknownAction>) => {
    dispatch(slice.actions.setOpenState(payload))
    dispatch(
      payload.open === null
        ? closeModal()
        : openModal({ type: FIND_RECIPIENTS_MODAL })
    )
  }
